<template>
  <Transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
interface IProps {
  appear?: boolean;
}
const props = withDefaults(defineProps<IProps>(), {
  appear: true,
});

const beforeEnter = (el) => {
  if (props.appear) {
    el.style.height = '0';
    el.style.willChange = 'height, opacity';
    el.style.overflow = 'hidden !important';
    el.style.opacity = 0;
  }
};

const enter = (el) => {
  if (props.appear) {
    // Get the scrollHeight to animate to its full height
    const height = el.scrollHeight;
    el.style.transition = 'height 0.5s ease, opacity 0.5s 0.125s linear';
    el.style.height = height + 'px';
    el.style.opacity = 1;
  }
};

const afterEnter = (el) => {
  if (props.appear) {
    // Clear the inline styles so the element can resize naturally
    el.style.height = 'auto';
    el.style.overflow = 'unset';
    el.style.transition = '';
  }
};

const beforeLeave = (el) => {
  // Set the height to its current computed height
  el.style.height = el.scrollHeight + 'px';
  el.style.overflow = 'hidden !important';
  el.style.opacity = 1;
};

const leave = (el) => {
  // Force reflow to ensure the transition is triggered
  void el.offsetHeight;
  el.style.transition = 'height 0.5s ease, opacity 0.5s 0.125s linear';
  el.style.height = '0';
  el.style.opacity = 0;
};

const afterLeave = (el) => {
  el.style.transition = '';
  el.style.overflow = 'unset';
};
</script>
